module.exports = __webpack_public_path__ + "img/contacts-mobile.adaa82a6.webp";